/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).load(function () {
          var offset = $("#masthead").outerHeight();
          $(".woocommerce-store-notice").css('top', offset + "px");

        });

        $(window).resize(function () {
          var offset = $("#masthead").outerHeight();
          $(".woocommerce-store-notice").css('top', offset + "px");
        });

        //Cookie Consent
        window.addEventListener("load", function () {
          window.cookieconsent.initialise({
            "palette": {
              "popup": {
                "background": "#000"
              },
              "button": {
                "background": "#c01718"
              }
            },
            "position": "bottom-right",
            "content": {
              "href": window.location.origin + "/privacy-policy",
            }
          });
        });

        $('.product-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 3000,
          centerMode: false,
          focusOnSelect: true,
          prevArrow: '<i class="product-slider-prev fa fa-chevron-left" aria-hidden="true"></i>',
          nextArrow: '<i class="product-slider-next fa fa-chevron-right" aria-hidden="true"></i>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 1
              }
            },
          ]
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Dynamicly set paddingtop on body to account for header height

        $(document).ready(function () {

          var mastHeadHeight = $("#masthead").css('height');
          $('.header-padding').css('padding-top', mastHeadHeight);

          $(window).resize(function () {
            var mastHeadHeight = $("#masthead").css('height');
            $('.header-padding').css('padding-top', mastHeadHeight);
          });

        });



        /*!
        * Bootstrap 4 multi dropdown navbar ( https://bootstrapthemes.co/demo/resource/bootstrap-4-multi-dropdown-navbar/ )
        */
        $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
          var $el = $(this);
          var $parent = $(this).offsetParent(".dropdown-menu");
          if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
          }
          var $subMenu = $(this).next(".dropdown-menu");
          $subMenu.toggleClass('show');
          $(this).parent("li").toggleClass('show');
          $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            $('.dropdown-menu .show').removeClass("show");
          });
          if (!$parent.parent().hasClass('navbar-nav')) {
            $el.next().css({ "top": $el[0].offsetTop, "left": $parent.outerWidth() - 4 });
          }
          return false;
        });

        // Select all links with hashes - ( https://css-tricks.com/snippets/jquery/smooth-scrolling/ )
        $('a[href*="#"]')
          // Remove links that don't actually link to anything
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function (event) {
            // On-page links
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                  scrollTop: target.offset().top
                }, 1000, function () {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  $target.focus();
                  if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                  } else {
                    $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                  }
                });
              }
            }
          });

        $('#search-nodata').hideseek({
          nodata: 'No results found',
          highlight: true
        });

      }
    },
    //Product page
    'single_product': {
      init: function () {
        // This button will increment the value
        $('.quantity .qty').before('<span class="quantity-text">Quantity*</span> <input type="button" value="-" class="qtyminus" field="quantity" />');
        $('.quantity .qty').after('<input type="button" value="+" class="qtyplus" field="quantity" />');
        $('.quantity .qty').attr('type', 'text');
        $('.qtyplus').click(function (e) {
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          fieldName = $(this).attr('field');
          // Get its current value
          var currentVal = parseInt($('input[name=' + fieldName + ']').val());
          // If is not undefined
          if (!isNaN(currentVal)) {
            // Increment
            $('input[name=' + fieldName + ']').val(currentVal + 1);
          } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
          }
        });
        // This button will decrement the value till 0
        $(".qtyminus").click(function (e) {
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          fieldName = $(this).attr('field');
          // Get its current value
          var currentVal = parseInt($('input[name=' + fieldName + ']').val());
          // If it isn't undefined or its greater than 0
          if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name=' + fieldName + ']').val(currentVal - 1);
          } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
          }
        });
      }
    },
    'basket': {
      init: function () {
        // This button will increment the value
        $('.quantity .qty').before('<input type="button" value="-" class="qtyminus" field="quantity" />');
        $('.quantity .qty').after('<input type="button" value="+" class="qtyplus" field="quantity" />');
        $('.quantity .qty').attr('type', 'text');
        $('.qtyplus').click(function (e) {
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          fieldName = $(this).attr('field');
          // Get its current value
          var currentVal = parseInt($('input[name=' + fieldName + ']').val());
          // If is not undefined
          if (!isNaN(currentVal)) {
            // Increment
            $('input[name=' + fieldName + ']').val(currentVal + 1);
          } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
          }
        });
        // This button will decrement the value till 0
        $(".qtyminus").click(function (e) {
          // Stop acting like a button
          e.preventDefault();
          // Get the field name
          fieldName = $(this).attr('field');
          // Get its current value
          var currentVal = parseInt($('input[name=' + fieldName + ']').val());
          // If it isn't undefined or its greater than 0
          if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name=' + fieldName + ']').val(currentVal - 1);
          } else {
            // Otherwise put a 0 there
            $('input[name=' + fieldName + ']').val(0);
          }
        });
      }
    },
    // Home page
    'home': {
      init: function () {
        //JavaScript to be fired on the home page
        $('.home-slider').slick({
          dots: true,
          arrows: false,
          infinite: true,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 8000,
          fade: true,
          cssEase: 'linear'
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    //brand template
    'page_template_template_product_area_php': {
      init: function () {
        // JavaScript to be fired on clinical-research pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Product slider
        $('.case-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 3000,
          centerMode: false,
          focusOnSelect: true,
          fade: true,
          cssEase: 'linear',
          prevArrow: '<i class="product-slider-prev fa fa-chevron-left" aria-hidden="true"></i>',
          nextArrow: '<i class="product-slider-next fa fa-chevron-right" aria-hidden="true"></i>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 1
              }
            },
          ]
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
